import authentication from '../../services/authentication';
import router from '../../router/index'

const token = localStorage.getItem('orbiter_jwt');
export const state = {
    status: false,
    token: token ? token : null,
    account: {},
};

export const actions = {
    login({dispatch, commit}, {username, password}) {
        commit('loginRequest');
        authentication.login(username, password)
            .then(
                response => {
                    commit('loginSuccess', response.data.token);
                    dispatch('identify');
                    router.push('/');
                },
                error => {
                    commit('loginFailure', error.response.data.error);
                    dispatch('notification/error', error.response.data.error, {root: true});
                }
            );
    },

    identify({dispatch, commit}) {
        authentication.identify()
            .then(
                response => {
                    commit('accountIdentify', response.data.payload.account);
                },
                error => {
                    dispatch('notification/error', error, {root: true});
                }
            );
    },

    logout({commit}) {
        authentication.logout();
        commit('logout');
    },

    register({dispatch, commit}, account) {
        commit('registerRequest', account);
        authentication.register(account)
            .then(
                account => {
                    commit('registerSuccess', account);
                    dispatch('notification/success', 'Registration successful', {root: true});
                },
                error => {
                    commit('registerFailure', error.response.data.error);
                    dispatch('notification/error', error.response.data.error, {root: true});
                }
            );
    }
};

export const mutations = {
    loginRequest(state) {
        state.status = false;
    },
    loginSuccess(state, token) {
        state.status = true;
        state.token = token;
    },
    loginFailure(state) {
        state.status = false;
        state.token = null;
    },
    accountIdentify(state, account) {
        state.account = account
    },
    logout(state) {
        state.status = false;
        state.token = null;
    },
    registerRequest(state) {
        state.status = false;
    },
    registerSuccess(state) {
        state.status = false;
    },
    registerFailure(state) {
        state.status = false;
    }
};

export const getters = {
    isLoggedIn: state => !!state.token
}
